module.exports = __webpack_public_path__ + "img/worth_3.28bf096c.png";